import { useEffect, useRef } from 'react';

export const WATCHLIST_REVIEW_HANDOFF_STATE_KEY = 'watchlistReviewHandoff';

const normalizeHandoff = (candidate) => {
    const revisionId = String(
        candidate?.revisionId || candidate?.watchlist_revision_id || '',
    ).trim();
    const sessionScopeToken = String(
        candidate?.sessionScopeToken || candidate?.session_scope_token || '',
    ).trim();
    const contextStatusReview = candidate?.origin === 'watchlist_context_status';
    if ((!revisionId && !contextStatusReview) || !sessionScopeToken) return null;
    return {
        origin: contextStatusReview ? 'watchlist_context_status' : 'watchlist_context_refresh',
        status: 'changes_awaiting_review',
        revisionId,
        revisionSeq: candidate?.revisionSeq ?? candidate?.revision_seq ?? null,
        sessionScopeToken,
    };
};

export const createWatchlistReviewNavigationState = (detail) => {
    const handoff = normalizeHandoff(detail);
    return handoff ? { [WATCHLIST_REVIEW_HANDOFF_STATE_KEY]: handoff } : null;
};

export default function useWatchlistReviewNavigationHandoff({
    location,
    navigate,
    onReviewHandoff,
}) {
    const consumedLocationKeyRef = useRef(null);

    useEffect(() => {
        const rawHandoff = location?.state?.[WATCHLIST_REVIEW_HANDOFF_STATE_KEY];
        if (!rawHandoff || typeof onReviewHandoff !== 'function') return;
        const locationKey = String(location?.key || '').trim();
        if (locationKey && consumedLocationKeyRef.current === locationKey) return;
        if (locationKey) consumedLocationKeyRef.current = locationKey;

        const handoff = normalizeHandoff(rawHandoff);
        if (handoff) onReviewHandoff(handoff);

        const nextState = { ...(location.state || {}) };
        delete nextState[WATCHLIST_REVIEW_HANDOFF_STATE_KEY];
        navigate({
            pathname: location.pathname,
            search: location.search || '',
            hash: location.hash || '',
        }, {
            replace: true,
            state: Object.keys(nextState).length ? nextState : null,
        });
    }, [location, navigate, onReviewHandoff]);
}
